export default "__VITE_ASSET__CIwn3CeE__"